/**
 * Which of its four states the finding page's Proposed fix section shows.
 * A failed read is never reported as "no fix yet": the reviewer would act on
 * an absence that is really an outage.
 *
 * @module components/regulation/finding/proposedFixState
 */
export type ProposedFixState = "loading" | "unavailable" | "empty" | "ready";

export function proposedFixState(input: {
  readonly loading: boolean;
  readonly unavailable: boolean;
  readonly hasProposal: boolean;
}): ProposedFixState {
  // A proposal already on screen stays while a refresh is in flight or fails.
  if (input.hasProposal) return "ready";
  if (input.loading) return "loading";
  if (input.unavailable) return "unavailable";
  return "empty";
}
